<div class="error error-{{ statusCode }}">
    <span class="error-title">
      {{ title | translate }}
    </span>
    <span class="message-detail" *ngIf="detail">
      {{ detail }}
    </span>
    <ul class="message-errors" *ngIf="hasErrors()">
        <li *ngFor="let error of errors">
            {{ error }}
        </li>
    </ul>
</div>
